export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Sök',
  catalogHeaderTitle: 'Detaljer',
  catalogDetailsCurtainCopyOptionTitle: 'Kopiera länk',
  catalogDetailsLinkCopiedAlertText: 'Länk kopierad!',
  catalogDetailsCurtainFlagOptionTitle: 'Anmäl innehåll',
  catalogDetailsFlagCurtainTitle: 'Anmäl',
  catalogReportedCurtainContent: 'Innehåll anmält',
  catalogWantBuy: 'Vill köpa {item} från {app}',
  catalogInterestedIn: '{link}'
}
